import styled from "styled-components";
import { SectionSubtitle, SectionTitle } from "components/Style";
import { PRODUCT_ADVANTAGES } from "appLauncher";

const ProductSection = styled.section`
  padding: 80px 0;
  background-color: #f8f8f8;
  cursor: default;
  user-select: none;
`;

const ProductContainer = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 15px;
`;

const ProductItems = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(384px, 1fr));
  gap: 30px;
  justify-content: center;
  align-items: center;
  margin-top: 32px;
`;

const ProductItem = styled.div`
  background-color: #fff;
  width: 384px;
  height: 141px;
  display: flex;
  align-items: center;
  justify-self: center;
  padding: 0 24px;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: background 0.2s, transform 0.3s;
  &:hover {
    background: #2640ed;
    transform: translateY(-5px);
    box-shadow: 0 8px 16px rgba(38, 64, 237, 0.12);
    & h3,
    & p,
    & div {
      color: #fff;
    }
  }
`;

const ProductIcon = styled.div`
  width: 54px;
  height: 54px;
  border-radius: 8px;
  margin-right: 24px;
  flex-shrink: 0;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  font-size: 2rem;
  color: #007bff;
  position: relative;
`;

const ProductItemTitle = styled.h3`
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-bottom: 8px;
  text-align: left;
`;

const ProductItemContent = styled.p`
  font-size: 14px;
  line-height: 1.6;
  color: #666;
  text-align: left;
  margin: 0;
`;

export default function ProductAdvantage() {
  return (
    <ProductSection>
      <ProductContainer>
        <SectionTitle>产品优势</SectionTitle>
        <SectionSubtitle>Product Advantages</SectionSubtitle>
        <ProductItems>
          {PRODUCT_ADVANTAGES.map((item, idx) => (
            <ProductItem key={idx}>
              <ProductIcon>
                <div
                  style={{
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "2rem",
                  }}
                >
                  <img src={item.icon} />
                </div>
              </ProductIcon>
              <div>
                <ProductItemTitle>{item.title}</ProductItemTitle>
                <ProductItemContent>{item.content}</ProductItemContent>
              </div>
            </ProductItem>
          ))}
        </ProductItems>
      </ProductContainer>
    </ProductSection>
  );
}
